import { range } from './range';
export function rangeOptions(min, max, step, format) {
    return range(min, max, step).map(function (it) {
        return {
            label: format(it),
            value: it,
        };
    });
}
